import { render, staticRenderFns } from "./ProspectInviteDecline.vue?vue&type=template&id=4afbc412&"
import script from "./ProspectInviteDecline.vue?vue&type=script&lang=js&"
export * from "./ProspectInviteDecline.vue?vue&type=script&lang=js&"
import style0 from "./ProspectInviteDecline.vue?vue&type=style&index=0&id=4afbc412&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports